<template>
  <v-container>
    <div class="mb-5">
      <material-card color="primary" title="Pengajuan Tandatangan Dokumen" class="card-wrapper">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                <v-text-field 
                  outlined 
                  dense
                  solo
                  readonly
                  class="primary--text"
                  v-model="namaOrganisasi"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Jenis Dokumen per Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                <v-text-field 
                  outlined 
                  dense
                  solo
                  readonly
                  class="primary--text"
                  v-model="namaDokumen"
                />
                <v-col cols="12" v-if="id_jenis_dokumen_organisasi != null">
                  
                </v-col>
              </div>
            </v-col>
            <!-- <div v-if="formData.id_jenis_dokumen_organisasi != null"> -->
              <v-col cols="12" md="3" v-if="formData.id_jenis_dokumen_organisasi != null">
                <p class="label font-weight-bold mb-1">Template Dokumen:</p>
                <b>{{ keteranganFileTemplate }}</b>
                <v-btn 
                v-if="fileTemplate != ''"
                @click="downloadFile()"
                target="_blank"
                class="white--text"
                color="primary"
                max-width="300px"
                >{{ displayFileTemplate }}</v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="formData.id_jenis_dokumen_organisasi != null">
                  <p class="label mb-3">Sifat kerahasiaan dokumen:&nbsp;<b>{{ tingkatKerahasiaan }}</b></p>
                  <p class="label font-weight-bold mb-1">Alur Persetujuan Dokumen:&nbsp;&nbsp;&nbsp; <b>{{ workflowPersetujuan }}</b></p>
              </v-col>
            <!-- </div> -->
            
          </v-row>
          <v-row v-if="formData.id_jenis_dokumen_organisasi != null">
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Upload File</p>
                <v-file-input accept=".pdf, .doc, .docx" v-model="file" hint="File berupa doc / docx / pdf" 
                  :persistent-hint=true dense outlined @change="loadSourcePdf()"
                  :rules="fileRules">
                </v-file-input>
              </div>
            </v-col>
            <v-col cols="12" md="6">
                <p class="label font-weight-bold mb-1">Nomor Surat/Dokumen</p>
                <v-text-field
                  placeholder="Nomor Surat/Dokumen"
                  outlined 
                  dense
                  clearable
                  class="primary--text"
                  v-model="formData.nomor_surat"
                  :rules="nomorSuratRules"
                >
                </v-text-field>
                <h5 style="color: red;">Pastikan Nomor Surat ini sudah benar dan sesuai, karena bersifat final.</h5>
            </v-col>
          </v-row>
          <v-row v-if="formData.id_jenis_dokumen_organisasi != null">
            <v-col cols="2">
                  <v-checkbox label="Atur Ulang Penandatangan" v-model="atur"/>
            </v-col>
          </v-row>
          <v-row v-if="formData.id_jenis_dokumen_organisasi != null">
            <v-col cols="12" md="6">
              <v-select
                label="Jenis Tanda Tangan"
                :items="jenisTtds"
                :item-text="item => item.Nama"
                :item-value="item => item.Id"
                :disabled="atur == false"
                no-data-text="Tidak ada data"
                v-model="chosenIdJenisTtds"
                @change="loadImages(true)"
                multiple
              />
            </v-col>
          </v-row> 
          <v-row v-if="formData.id_jenis_dokumen_organisasi != null">
            <v-col cols="12" md="6">
              <v-card elevation="2">
                <v-card-title>
                  Daftar Pemaraf
                </v-card-title>
                <v-container>
                  <v-row>
                      <v-col cols="12" sm="6" md="10">
                        <v-autocomplete
                          :items="dropdownPemarafTtd"
                          :item-text="item => item.nama_lengkap + ' - ' + item.jabatan"
                          :item-value="item => item"
                          placeholder="Pilih Pemaraf"
                          clearable
                          dense
                          outlined
                          no-data-text="Tidak ada data"
                          v-model="selectedPemaraf"
                          :disabled="atur == false"
                          :loading="loading"
                          @keydown.enter.prevent
                        >
                        </v-autocomplete>
                        <h6 style="color: red;">{{ pemarafError }}</h6>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-btn v-if="atur" color="primary" dark @click="addPemaraf">Tambah</v-btn>
                      </v-col>
                  </v-row>
                  <v-simple-table v-if="chosenPemarafs.length > 0">
                    <template v-slot:default>
                      <thead>
                          <tr>
                            <th class="text-left">No</th>
                            <th class="text-left">Nama</th>
                            <th class="text-left">Perlu Visual Paraf</th>
                            <th v-if="atur" class="text-left">Aksi</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(i, key) in chosenPemarafs">
                            <td>{{ i.urutan_hirarki }}</td>
                            <td>{{ i.nama_lengkap + ' - ' + i.jabatan }}</td>
                            <td><v-checkbox v-model= i.flag_visual :disabled="!atur" @change="loadImages(true)"/></td>
                            <td v-if="atur">
                              <v-btn
                                color="red"
                                class="mr-4"
                                @click="hapusPemaraf(i.urutan_hirarki)">
                                Hapus
                              </v-btn>
                            </td>
                          </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card elevation="2">
                <v-card-title>
                  Daftar Penandatangan
                </v-card-title>
                <v-container>
                  <v-row>
                      <v-col cols="12" sm="6" md="10">
                        <v-autocomplete
                          :items="dropdownPemarafTtd"
                          :item-text="item => item.nama_lengkap + ' - ' + item.jabatan"
                          :item-value="item => item"
                          placeholder="Pilih Penandatangan"
                          :disabled="atur == false"
                          clearable
                          dense
                          outlined
                          no-data-text="Tidak ada data"
                          v-model="selectedPenandatangan"
                          :loading="loading"
                          @keydown.enter.prevent
                        >
                        </v-autocomplete>
                        <h6 style="color: red;">{{ penandatanganError }}</h6>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-btn v-if="atur" color="primary" dark @click="addPenandatangan">Tambah</v-btn>
                      </v-col>
                  </v-row>
                  <v-simple-table v-if="chosenPenandatangans.length > 0">
                    <template v-slot:default>
                      <thead>
                          <tr>
                            <th class="text-left">No</th>
                            <th class="text-left">Nama</th>
                            <th class="text-left">Perlu Visual Tandatangan</th>
                            <th v-if="atur" class="text-left">Aksi</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(i, key) in chosenPenandatangans">
                            <td>{{ i.urutan_hirarki }}</td>
                            <td>{{ i.nama_lengkap + ' - ' + i.jabatan }}</td>
                            <td><v-checkbox v-model= i.flag_visual :disabled="!atur" @change="loadImages(true)"/></td>
                            <td v-if="atur">
                              <v-btn
                                color="red"
                                class="mr-4"
                                @click="hapusPenandatangan(i.urutan_hirarki)">
                                Hapus
                              </v-btn>
                            </td>
                          </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="12">
                  <v-checkbox label="Saya telah mengonfirmasi data penandatangan dan kesesuaian dokumen di atas" v-model="confirm"/>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="gray" v-show="file != null" dark @click="preview()">Preview</v-btn>
                <v-dialog
                  v-model="dialog"
                  persistent
                  style="z-index:99999;">
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Preview Dokumen
                    </v-card-title>

                    <v-card-text>
                      <DragAndDrop :source="sourcePdf" :ttd-items="imagePdfItems" :dialog="dialog" :permission="'Tambah'" ref="dragdrop">
                      </DragAndDrop>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Tutup
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>&nbsp;
                <v-btn color="primary" v-show="confirm == true && formData.nomor_surat" dark @click="handleSubmit()">Proses</v-btn>&nbsp;
                <!-- <v-btn color="red" dark @click="back()">Batal</v-btn> -->
            </v-col>
          </v-row>
        </v-form>
      </material-card>
      <v-overlay
        :opacity="0.5"
        :value="overlay"
      >
        <v-progress-circular indeterminate size="64">
          Loading...
        </v-progress-circular>
      </v-overlay>
    </div>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
  
</template>

<script>
import axios from 'axios'
import { apiServer, docConverter } from "../../setup-axios";
import DragAndDrop from "../jenisDokumenOrganisasi/DragAndDrop.vue";
import { stampPath } from '../../config/env'
import { qrPlaceHolder } from '../../config/env'
import { bsreDisclaimer } from '../../config/env'
import { parafPath } from '../../config/env'
import { signPath } from '../../config/env'
import { documentPath } from '../../config/env'

// import pdf from "vue-pdf";

export default {
  data: () => ({
    loading: false,
    loadingHapus: false,
    pemarafError: "",
    penandatanganError: "",
    jdo: [],
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    workflowPersetujuan: "",
    wp: true,
    duplicateValid: true,
    namaOrganisasi: "",
    objectOrg: null,
    organisasis:[],
    chosenPemarafs: [],
    chosenPenandatangans: [],
    selectedPemaraf: null,
    selectedPenandatangan: null,
    sourcePdf: null,
    sourcePdfBlob: null,
    dropdownPemarafTtd: [],
    tingkatKerahasiaan: "",
    path: window.location.pathname,
    deleteIndexPemaraf: -1,
    keteranganFileTemplate: "",
    fileTemplate: "",
    displayFileTemplate: "",
    atur: false,
    formData: {
      id: null,
      id_jenis_dokumen_organisasi: null,
      id_status_dokumen: null,
      code_transaction: "",
      nomor_surat: "",
      pengguna_entry: "",
      source_apk: "",
      ttd_arsip_dokumen: [],
      jenis_ttd_arsip_dokumen: []
    },
    file: null,
    jenisTtds: [],
    chosenJenisTtds:[],
    chosenIdJenisTtds: [],
    confirm:false,
    deleteIndexPenandatangan: -1,
    deleteIndexPemaraf: -1,
    filePDF: null,
    overlay: false,
    dialog: false,
    organisasiFileStamp: "",
    kodeOrg: "",
    namaDokumen: "",
    peran: "",
    user: {
      username:""
    },
    np: "",
    headers: null,
    imagePdfItems: [],
    ttdJenisDokumen: [],
    pdfSubmit: "",
    imgParameter: "",
    imagePdfItemsTmp :[],
    disclaimer: null,
    disclaimerFontSize: null,
  }),
  components: { DragAndDrop },
  computed: {
    fileRules() {
      return [  v => {
          if (!v) {
              return 'File Harus Diisi'
          }
        }
      ]
    },
    nomorSuratRules() {
      return [  v => {
          if (!v) {
              return 'Nomor Surat Harus Diisi'
          }
        }
      ]
    },
  },
  props: {
      id_jenis_dokumen_organisasi: null,
      code_override: "",
      code_transaction: "",
      token: "",
      file_name: "",
      source: "",
      pengguna_entry: "",
      nomor_surat: "",
  },
  mounted() {
    this.formData.nomor_surat = this.nomor_surat;
    this.formData.code_transaction = this.code_transaction
    apiServer.defaults.headers.common['Authorization'] = 'Bearer ' + this.token
    apiServer.defaults.headers.common['X-Token-Type'] = 'Internal'

    console.log('id_jenis_dokumen_organisasi:', this.id_jenis_dokumen_organisasi);
    console.log('token:', this.token);
    console.log('file_name:', this.file_name);
    console.log('source:', this.source);
    console.log('pengguna_entry:', this.pengguna_entry);
    console.log('nomor_surat props:', this.nomor_surat);
    console.log('nomor_surat urlparam:', this.formData.nomor_surat);
    console.log('Authorization header:', apiServer.defaults.headers.common['Authorization']);
    console.log('X-Token-Type header:', apiServer.defaults.headers.common['X-Token-Type']);
    if(localStorage.getItem('user')) {
      localStorage.clear()
    }
    this.initiate()

    this.getData()
    this.getDisclaimerBsre()
  },
  methods: {
      initiate() {
        localStorage.setItem("user", JSON.stringify({username: this.pengguna_entry}));

        // if (this.token == "") {
        //   this.$router.push("/");
        // }
        // apiServer.get("/esign/extract-token").then(response => {
        //   localStorage.setItem("user", response.data.data);
        //   localStorage.setItem("token", response.data.data.token);
        //   this.user = response.data.data;
        // })
        // .catch(error => {
        //   console.log("There was an error:", error.response.data.message); // Logs out the error
        // });
      },
      getDisclaimerBsre() {
        apiServer
          .get("/arsip/disclaimer_bsre")
          .then(response => {
            this.disclaimer = response.data.data.disclaimer;
            this.disclaimerFontSize = response.data.data.disclaimerFontSize;
            console.log("disclaimer " + JSON.stringify(response.data.data))
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      },
      getData() {
          if (this.id_jenis_dokumen_organisasi && this.file_name != "") {
              // this.namaDokumen = this.id_jenis_dokumen_organisasi
              this.formData.id_jenis_dokumen_organisasi = parseInt(this.id_jenis_dokumen_organisasi)
              this.getNamaOrganisasi()
              this.getNamaDokumen()
              this.getTingkatKerahasiaan()
              this.getJenisDokumenOrganisasi()
              this.getDropdownJenisTtd()
              this.getDropdownPemarafTtd()
              if (this.file_name != "") {
                  this.loadInputFile()
              }
          }
      },
      getNamaOrganisasi() {
          apiServer
          .get("/arsip/organisasi_by_id_jdo/"+this.id_jenis_dokumen_organisasi)
          .then(response => {
              this.objectOrg = response.data.data
              this.namaOrganisasi = response.data.data.nama
              this.organisasiFileStamp = response.data.data.file_stamp
              this.kodeOrg = response.data.data.kode_org
              this.formData.id_organisasi = response.data.data.id
          })
          .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      },
      getNamaDokumen() {
          apiServer
          .get("/arsip/jenis_dokumen_by_id_jdo/"+this.id_jenis_dokumen_organisasi)
          .then(response => {
              this.namaDokumen = response.data.data.nama
              this.workflowPersetujuan = response.data.data.alur_persetujuan
          })
          .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      },
      getTingkatKerahasiaan() {
          apiServer
          .get("/arsip/kerahasiaan_by_id_jdo/"+this.id_jenis_dokumen_organisasi)
          .then(response => {
              this.tingkatKerahasiaan = response.data.data.nama
          })
          .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      },
      async getJenisDokumenOrganisasi() {
        this.imagePdfItems = []
        this.imagePdfItemsTmp = []
        await apiServer
            .get("/jenis_dokumen_organisasi/find?id=" + this.id_jenis_dokumen_organisasi)
            .then(async response => {
              this.fileTemplate = response.data.data.file_dokumen
              this.fileTemplate = this.fileTemplate.replace(/^.*[\\/]/, '')
              this.displayFileTemplate = this.shortenFileTemplate(this.fileTemplate)
              if (this.fileTemplate=='') this.keteranganFileTemplate = 'Jenis dokumen ini tidak memiliki file template'
              
              this.chosenPemarafs = []
              this.chosenPenandatangans = []
              this.chosenIdJenisTtds = []
              let ttds = []
              if (this.code_override) {
                ttds = await this.getTempTtdOverride(this.code_override)
                console.log("temp override length:",ttds.length)
              } else {
                ttds = response.data.data.ttd_jenis_dokumen
              }
                  ttds.forEach((item, index) => {
                // response.data.data.ttd_jenis_dokumen.forEach((item, index) => {
                  let p = {
                        id_pengguna	:	item.Pengguna.id,
                        username: item.Pengguna.username,
                        nama_lengkap :	item.Pengguna.nama_lengkap,
                        file_ttd	: item.Pengguna.file_ttd,
                        file_paraf	: item.Pengguna.file_paraf,
                        jabatan	: item.Pengguna.jabatan,
                        urutan_hirarki	:	item.urutan_hirarki,
                        tipe_ttd	:	item.tipe_ttd,
                        id_jenis_ttd: item.id_jenis_ttd,
                        flag_visual : item.flag_visual,
                        koordinat	:	item.koordinat,
                        halaman	:	item.halaman
                      } 
                    if (item.tipe_ttd == 1) {
                        this.chosenPemarafs.push(p)
                    }
                    if (item.tipe_ttd == 2) {
                        this.chosenPenandatangans.push(p)
                    }
                    if (item.id_jenis_ttd) {
                        this.chosenIdJenisTtds.push(item.id_jenis_ttd)
                    }
              });
              // this.ttdJenisDokumen = response.data.data.ttd_jenis_dokumen
              this.ttdJenisDokumen = ttds

              await this.loadImages(false)
              await this.fillKoordinatTtdItems()
              this.imagePdfItemsTmp = Object.assign([], this.imagePdfItems)
        })
            .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
        });
      },
      shortenFileTemplate(file) {
          var length = 20;
          var trimmedString = file.length > length ? file.substring(0, length - 3) + "..." : file;
          return trimmedString
      },
      loadInputFile() {
        const timestamp = new Date().getTime()
        apiServer
          .get("/files/get-by-filepath?target_path="+documentPath+"/"+this.file_name+".pdf&type=download&timestamp=" + timestamp, {
          responseType: "blob"
        })
          .then(response => {
            var fileBlob = new Blob([response.data])
            this.file = new File([fileBlob], this.file_name +".pdf")
            console.log("preloaded file type",this.file instanceof File)
            this.loadSourcePdf()
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      },
      aturUlang() {
          console.log(this.atur)
      },
      async getTempTtdOverride(code_override) {
        let list = []
          await apiServer
              .get("/arsip/override/"+code_override)
              .then(response => {
                  list = response.data.data 
                  list.forEach(item => {
                    item.koordinat	=	""
                    item.halaman	=	null
                  })
                  console.log("temp_override", JSON.stringify(list))
                  
              })
              .catch(error => {
                  console.log("There was an error:", error.response.data.message); // Logs out the error
              });
              return list
      },
      getDropdownJenisTtd() {
          apiServer
              .get("/arsip/jenis_ttd")
              .then(response => {
                  // console.log(response.data.data)
                  this.jenisTtds = response.data.data;
                  this.chosenJenisTtds = []
                  this.jenisTtds.forEach((item, index) => {
                        this.chosenJenisTtds.push({
                            id_jenis_ttd : item.Id,
                            flag_visual: false,
                        })
                    })
              })
              .catch(error => {
                  console.log("There was an error:", error.response.data.message); // Logs out the error
              });
      },
      getDropdownPemarafTtd() {
          apiServer
              .get("/arsip/dropdown_pemaraf_ttd")
              .then(response => {
              this.dropdownPemarafTtd = response.data.data;
              })
              .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
              });
      },
    addPemaraf() {
      console.log("adding ttd: " + JSON.stringify(this.selectedPemaraf))
      if(!this.selectedPemaraf) {
        this.pemarafError = "Pilih pemaraf untuk melakukan Tambah"
      } else if(this.workflowPersetujuan === "") {
        this.pemarafError = "Isi Jenis Dokumen per Organisasi terlebih dahulu untuk menentukan jumlah pemaraf yang dapat diisi"
      } else if (this.selectedPemaraf.file_paraf == '') {
        this.pemarafError = "Pemaraf belum memiliki file paraf"
      } else {
        this.pemarafError = ""
        let parafAppend = {
          id_pengguna	:	this.selectedPemaraf.id,
          username: this.selectedPemaraf.username,
          nama_lengkap :	this.selectedPemaraf.nama_lengkap,
          jabatan	:	this.selectedPemaraf.jabatan,
          urutan_hirarki	:	this.chosenPemarafs.length + 1,
          tipe_ttd	:	1,
          koordinat	:	"",
          halaman	:	null,
          file_paraf : this.selectedPemaraf.file_paraf,
        }
        this.chosenPemarafs.push(parafAppend)
      }
    },
    hapusPemaraf(urutan_hirarki) {
      this.deleteIndexPemaraf = -1
      this.chosenPemarafs.forEach((item, index) => {
        if(item.urutan_hirarki == urutan_hirarki) {
          this.deleteIndexPemaraf = index
        }
      })
      if(this.deleteIndexPemaraf >= 0) {
        this.chosenPemarafs.splice(this.deleteIndexPemaraf, 1)
        this.chosenPemarafs.forEach((item, index) => {
          item.urutan_hirarki = index+1
        })
      }
    },
    addPenandatangan() {
      console.log("adding ttd: " + JSON.stringify(this.selectedPenandatangan))
      if(!this.selectedPenandatangan) {
        this.penandatanganError = "Pilih penandatangan untuk melakukan Tambah"
      } else if(this.workflowPersetujuan === "") {
        this.penandatanganError = "Isi Jenis Dokumen per Organisasi terlebih dahulu untuk menentukan jumlah penandatangan yang dapat diisi"
      } else if(this.workflowPersetujuan === "Langsung" && this.chosenPenandatangans.length > 0) {
        this.penandatanganError = "Workflow Persetujuan Langsung hanya bisa memilih 1 penandatangan"
      } else if (this.selectedPenandatangan.file_ttd == '') {
        this.penandatanganError = "Penandatangan belum memiliki file tanda tangan"
      } else {
        this.penandatanganError = ""
        let ttdAppend = {
          id_pengguna	:	this.selectedPenandatangan.id,
          username: this.selectedPenandatangan.username,
          nama_lengkap :	this.selectedPenandatangan.nama_lengkap,
          jabatan	:	this.selectedPenandatangan.jabatan,
          urutan_hirarki	:	this.chosenPenandatangans.length + 1,
          tipe_ttd	:	2,
          koordinat	:	"",
          halaman	:	null,
          file_ttd : this.selectedPenandatangan.file_ttd,
        }
        // this.selectedPenandatangan.urutan = this.chosenPenandatangans.length + 1
        this.chosenPenandatangans.push(ttdAppend)
      }
    },
    hapusPenandatangan(urutan_hirarki) {
      this.deleteIndexPenandatangan = -1
      this.chosenPenandatangans.forEach((item, index) => {
        if(item.urutan_hirarki == urutan_hirarki) {
          this.deleteIndexPenandatangan = index
        }
      })
      if(this.deleteIndexPenandatangan >= 0) {
        this.chosenPenandatangans.splice(this.deleteIndexPenandatangan, 1)
        this.chosenPenandatangans.forEach((item, index) => {
          item.urutan_hirarki = index+1
        })
      }
    },
    async preview() {
      // this.setupFormDataBeforeSubmit()
        await this.loadImages(true)
        this.dialog = true    
    },
    validateAll () {
      this.$refs.form.validate()
    },
    async fillChosenJenisTtds() {
      // reset all flag visual of jenis ttd into false
      console.log("chosenJenisTtds: " + JSON.stringify(this.chosenJenisTtds) )
      for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
          this.chosenJenisTtds[ii].flag_visual = false
      }
      // set Id and file path of selected jenis ttd
      for(var jj = 0; jj < this.chosenIdJenisTtds.length; jj++) {
          let item = this.chosenIdJenisTtds[jj]
          let filePath = null
          let itemId = null
          if (item == 1) {
              // find stamp file for selected organisasi
              
              itemId = this.objectOrg.nama.trim().replaceAll(' ', '_') + '_organisasi'
              filePath = await this.loadBase64File(stampPath + '/' + this.objectOrg.file_stamp)
              // console.log("stamp: " + itemId +" file stamp: " + filePath )
              // for(var kk = 0; kk < this.organisasis.length; kk++) {
              //     var itemOrg = this.organisasis[kk] 
              //     if (itemOrg.id == this.formData.id_organisasi) {
              //         itemId = itemOrg.nama.trim().replaceAll(' ', '_') + '_organisasi'
              //         filePath = await this.loadBase64File(stampPath + '/' + itemOrg.file_stamp)
              //     }
              // };
          } else if(item == 2) {
              itemId = "QRCode"
              filePath = qrPlaceHolder
              // console.log("qrcode: " + itemId +" file stamp: " + filePath )
          } //else {
              //itemId = "DeskripsiQR"
              //filePath = bsreDisclaimer
              // console.log("deskripsiqr: " + itemId +" file stamp: " + filePath )
          //}
          for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
              if(item + '' === this.chosenJenisTtds[ii].id_jenis_ttd + '') {
                  this.chosenJenisTtds[ii].flag_visual = true
                  this.chosenJenisTtds[ii].id = itemId
                  this.chosenJenisTtds[ii].filePath = filePath
              }
          }
      }
    },
    setupFormDataBeforeSubmit() {
      this.formData.source_apk = this.source
      this.formData.pengguna_entry = this.pengguna_entry
      this.formData.ttd_arsip_dokumen = []
      this.chosenPemarafs.forEach((item, index) => {
        if (this.workflowPersetujuan == 'Grup' || this.workflowPersetujuan == 'Langsung') item.urutan_hirarki = 1
        item.flag_urutan = item.urutan_hirarki == 1 ? true : false 

        var koordinatSave = null
        var pageSave = null
        if(item.flag_visual) {
          var imagePdf = this.findElementById(item.username.replace('.', '_') + '_paraf', this.imagePdfItems)
          delete imagePdf.koordinat.base64Src
          imagePdf.koordinat.id = imagePdf.id
          koordinatSave = JSON.stringify(imagePdf.koordinat)
          pageSave = imagePdf.page
        }

        this.formData.ttd_arsip_dokumen.push({
          id_pengguna: item.id_pengguna,
          pengguna_entry: this.pengguna_entry,
          koordinat: koordinatSave,
          halaman: pageSave,
          urutan_ttd: item.urutan_hirarki,
          flag_visual: item.flag_visual,
          tipe_ttd: 1,
          flag_ttd:false,
          jabatan: item.jabatan,
          flag_urutan: item.flag_urutan
        })
      })
      this.chosenPenandatangans.forEach((item, index) => {
        if (this.workflowPersetujuan == 'Grup' || this.workflowPersetujuan == 'Langsung') item.urutan_hirarki = 1
        if (this.chosenPemarafs.length == 0) {
          item.flag_urutan = item.urutan_hirarki == 1 ? true : false
        } else {
          if (this.workflowPersetujuan == 'Berjenjang') {
            item.flag_urutan = false
          } else {
            item.flag_urutan = true
          }
        }
        var koordinatSave = null
        var pageSave = null
        if(item.flag_visual) {
          var imagePdf = this.findElementById(item.username.replace('.', '_') + '_ttd', this.imagePdfItems)
          delete imagePdf.koordinat.base64Src
          imagePdf.koordinat.id = imagePdf.id
          koordinatSave = JSON.stringify(imagePdf.koordinat)
          pageSave = imagePdf.page
        }
        this.formData.ttd_arsip_dokumen.push({
          id_pengguna: item.id_pengguna,
          pengguna_entry: this.pengguna_entry,
          koordinat: koordinatSave,
          halaman: pageSave,
          urutan_ttd: item.urutan_hirarki,
          flag_visual: item.flag_visual,
          tipe_ttd: 2,
          jabatan: item.jabatan,
          flag_ttd:false,
          flag_urutan: item.flag_urutan
        })
      })
      this.formData.jenis_ttd_arsip_dokumen = []
      //stamp, qr, deskripsi qr
      this.chosenJenisTtds.forEach((item, index) => {
        // check if chosenJenisTtds are selected
        var imagePdf = this.findElementById(item.id, this.imagePdfItems)
        if (item.flag_visual) {
            delete imagePdf.koordinat.base64Src
            imagePdf.koordinat.id = imagePdf.id
            this.formData.jenis_ttd_arsip_dokumen.push({
                id_jenis_ttd: item.id_jenis_ttd,
                flag_visual: true,
                koordinat: JSON.stringify(imagePdf.koordinat),
                halaman: imagePdf.page
            });
        }
      });
      console.log("jenis ttd "+JSON.stringify(this.chosenJenisTtds))
      console.log("form jenis ttd " + JSON.stringify(this.formData.jenis_ttd_arsip_dokumen))
    },
    async deleteTemporaryTtd() {
      let successDelete = false 
      await apiServer
      .delete("/arsip/override/delete/"+ this.code_override)
      .then(response => {
        console.log("response delete temp ttd", JSON.stringify(response.data))
        if (response.data.code == 200) {
          successDelete = true
        }
      })
      .catch(error => {
        console.log("There was an error:", error.response.data.message); // Logs out the error
        successDelete = false
        this.showSnackbar("error", error.response.data.message);
      }); 
      return successDelete
    },
    async deleteTemporaryFile() {
      let successDelete = false 
      await apiServer
      .delete("/arsip/delete_temp_file/"+ this.file_name)
      .then(response => {
        console.log("response delete temp file", JSON.stringify(response.data))
        if (response.data.code == 200) {
          successDelete = true
        }
      })
      .catch(error => {
        console.log("There was an error:", error.response.data.message); // Logs out the error
        this.showSnackbar("error", error.response.data.message);
      });
      return successDelete
    },
    async handleSubmit() {
      let validation = true
      if (this.code_override) {
        console.log("has temp ttd")
        validation = await this.deleteTemporaryTtd()
      }
      if (this.file_name) {
        console.log("has temp file")
        validation = await this.deleteTemporaryFile()
      }
      if (validation) {
        console.log("ready submit")
        this.submit()
      }
    },
    async submit() {
      
      var validPemarafTtd = this.workflowPersetujuan != "Langsung" || this.chosenPenandatangans.length <= 1
      if(this.$refs.form.validate() && validPemarafTtd && this.file != null) {
        this.overlay = true
        this.pemarafError=""
        this.penandatanganError=""
        this.setupFormDataBeforeSubmit()
        console.log("ttd "+JSON.stringify(this.formData.ttd_arsip_dokumen))
        console.log(this.workflowPersetujuan)
        if (this.chosenPenandatangans.length > 0) {
          if (this.formData.ttd_arsip_dokumen.length <= 1 && (this.workflowPersetujuan == 'Berjenjang' || this.workflowPersetujuan == 'Grup')) {
            this.showSnackbar("error", "Workflow Persetujuan Berjenjang atau Grup harus lebih dari 1 penandatangan");
            this.overlay = false
          } else {
            await this.setupBackendPdfStampInput()
            var formdata = new FormData()
            formdata.append("ArsipDokumen", JSON.stringify(this.formData))
            formdata.append("KodeOrganisasi", this.kodeOrg)
            formdata.append("AlurPersetujuan", this.workflowPersetujuan)
            formdata.append("NamaJenisDokumen", this.namaDokumen)
            formdata.append("PdfSource", this.pdfSubmit)
            formdata.append("ImgParameter", this.imgParameter)
            formdata.append("file", this.file)
            for (var pair of formdata.entries()) {console.log(pair[0]+ ': ' + pair[1]); }
            apiServer
              .post("/arsip/create", formdata)
              .then(response => {
                console.log("inserted data: ", response.data.data)
                var nomor_surat = this.formData.nomor_surat
                this.id_jenis_dokumen_organisasi = null
                this.$refs.form.reset()
                // this.$router.push('/dokumen/detail/'+response.data.data.id);
                this.overlay = false
                this.showSnackbar('success', "Pengajuan tandatangan digital dengan nomor surat "+nomor_surat+" berhasil di simpan")
              })
              .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
                this.overlay = false
                this.showSnackbar("error", error.response.data.message);
              });
            }
        } else {
          this.showSnackbar("error", "Daftar penandatangan kosong. Harap isi terlebih dahulu");
          this.overlay = false
        }
      } else if(!validPemarafTtd){
        console.log('invalid form')
        this.showSnackbar("error", "Workflow Persetujuan Langsung hanya bisa memilih 1 penandatangan");
        this.overlay = false
      } else if (this.file == null) {
        this.showSnackbar("error", "File Harus Diisi");
        this.overlay = false
      }
    },
    downloadFile() {     
      const timestamp = new Date().getTime()
      apiServer
        .get("/files/get-by-filepath?target_path="+documentPath+"/"+this.fileTemplate+"&type=download&timestamp=" + timestamp, {
          responseType: "blob"
        })
        .then(response => {
          // console.log(response.data)
          const bb = new Blob([response.data])
          const data = window.URL.createObjectURL(bb);
          // this.pdfsrc = data; //untuk tampilin di <pdf>
          const link = document.createElement('a');
          link.href = data;
          link.setAttribute('download', this.fileTemplate);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(bb)
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    back() {
      // console.log(this.chosenJenisTtds)
      this.$router.push('/dokumen');
    },
    showSnackbar(color, message) {
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    async loadSourcePdf() {
      console.log("input file type",typeof(this.file))
      console.log(this.file)
      this.sourcePdf = null
      if(this.file) {
          var blob = await new Blob([this.file], { type: 'application/pdf' })
          this.sourcePdfBlob = blob
          var urlCreator = window.URL || window.webkitURL;
          var base64Pdf = await this.convertPdfToBase64()
          const timestamp = new Date().getTime()
          console.log('url', docConverter.defaults.baseURL)
          await docConverter
          .post("/watermark-document?timestamp=" + timestamp, {
              pdfBase64: base64Pdf,
              imgParameter: "",
              username: this.pengguna_entry,
              disclaimer: this.disclaimer,
              disclaimerFontSize: this.disclaimerFontSize
            }, {responseType: "blob"})
          .then(response => {
            const bb = new Blob([response.data])
            blob = bb
          })
          .catch(error => {
            console.log('watermark error')
            console.log(error)
            console.log("There was an error:", error.response.data.message); // Logs out the error
          });
          
          this.sourcePdf =  await urlCreator.createObjectURL(blob)
      }
    },
    // drag and drop related
      findElementById(id, array) {
          for(var ii = 0; ii < array.length; ii++) {
              if((id + '') === (array[ii].id + '')) {
                  return array[ii]
              }
          }
          return null
      },
      // drag and drop related
      async loadImages(readExistingElement) {
        //alert('load')
        await this.fillChosenJenisTtds()
        var newImagePdfItems = []
        // console.log("chosenJenisTtds", JSON.stringify(this.chosenJenisTtds))
        await this.chosenJenisTtds.forEach((item, index) => {
            if(item.flag_visual === true) {
                var elementExists = this.findElementById(item.id, this.imagePdfItems)
                // console.log("element jenis exist", elementExists)
                if(elementExists && this.sourcePdf && readExistingElement) {
                    newImagePdfItems.push(elementExists)
                } else  {
                    newImagePdfItems.push({path: item.filePath, 
                        id: item.id})
                }
            }
        })

        for(var ii = 0; ii < this.chosenPemarafs.length; ii++) {
            var item = this.chosenPemarafs[ii]
            var idPdfItem = item.username.replace('.', '_') + "_paraf"
            if(item.flag_visual === true) {
                var elementExists = this.findElementById(idPdfItem, this.imagePdfItems)
                if(elementExists && this.sourcePdf && readExistingElement) {
                    newImagePdfItems.push(elementExists)
                } else  {
                    var pathBase64 = await this.loadBase64File(parafPath + '/' + item.file_paraf)
                    newImagePdfItems.push({path: pathBase64, 
                        id: idPdfItem})
                }
            }
        }

        for(var ii = 0; ii < this.chosenPenandatangans.length; ii++) {
            var item = this.chosenPenandatangans[ii]
            var idPdfItem = item.username.replace('.', '_') + "_ttd"
            if(item.flag_visual === true) {
                var elementExists = this.findElementById(idPdfItem, this.imagePdfItems)
                console.log(this.imagePdfItems)
                if(elementExists && this.sourcePdf && readExistingElement) {
                    newImagePdfItems.push(elementExists)
                } else  {
                    var pathBase64 = await this.loadBase64File(signPath + '/' + item.file_ttd)
                    newImagePdfItems.push({path: pathBase64, 
                        id: idPdfItem})
                }
            }
        }

        this.imagePdfItems = newImagePdfItems
    },
    // drag and drop related
    async loadBase64File(path) {
      //alert(path)
      var base64 = ""
      const timestamp = new Date().getTime()
      await apiServer
          .get("/files/get-base64-image?target_path="+path+"&timestamp="+timestamp)
          .then(response => {
              base64 = response.data.data
          })
          .catch(error => {
              console.log("There was an error:", error.response.data.message); // Logs out the error
          });
      return base64
    },
    // drag and drop related
    async fillKoordinatTtdItems() {
          //loop ttd_jenis_dokumen
          await this.ttdJenisDokumen.forEach((item, index) => {
              //alert(JSON.stringify(item))
              // if the item is of pemaraf
              // use username_paraf to find element in ttdItems
              // fill koordinat in ttdItems from ttd_jenis_dokumen
              if (item.tipe_ttd == 1 && item.flag_visual) {
                  var element = this.findElementById(item.Pengguna.username.replace('.', '_') + '_paraf', this.imagePdfItems)
                  element.koordinat = JSON.parse(item.koordinat)
                  element.page = item.halaman
              }
              // if the item is of penandatangan
              // use username_ttd to find element in ttdItems
              // fill koordinat in ttdItems from ttd_jenis_dokumen
              if (item.tipe_ttd == 2 && item.flag_visual) {
                  var element = this.findElementById(item.Pengguna.username.replace('.', '_') + '_ttd', this.imagePdfItems)
                  element.koordinat = JSON.parse(item.koordinat)
                  element.page = item.halaman
              }
              // if the item is of jenisTtd
              // find id used in ttdItems in chosenJenisTtds
              // use id to find element in ttdItems
              // fill koordinat in ttdItems from ttd_jenis_dokumen
              if (item.id_jenis_ttd) {
                  var chosenJenisTtd = null
                  for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
                      if(this.chosenJenisTtds[ii].id_jenis_ttd == item.id_jenis_ttd) {
                          chosenJenisTtd =  this.chosenJenisTtds[ii]
                      }
                  }
                  if(chosenJenisTtd) {
                      var element = this.findElementById(chosenJenisTtd.id, this.imagePdfItems)
                      element.koordinat = JSON.parse(item.koordinat)
                      element.page = item.halaman
                  }
              }
          });
      },
      async convertPdfToBase64() {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(this.sourcePdfBlob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });
      },
      async apiGeneratePdf() {
        var array = []
        for(var ii = 0; ii < this.imagePdfItems.length; ii++) {
          var item = Object.assign([], this.imagePdfItems[ii])
          item.koordinat.base64Src = this.imagePdfItems[ii].path
          array.push(item.koordinat)
        }
        var pdfSource = await this.convertPdfToBase64()
        const timestamp = new Date().getTime()

        return await docConverter
          .post('/generate-document-final'+ '?timestamp=' + timestamp, {
              pdfBase64: pdfSource,
              imgParameter: JSON.stringify(array),
              username: this.pengguna_entry
          })
          .then(response => {
            return response.data
          })
          .catch(error => {
            console.log(error)
            throw error
          });
      },
      async setupBackendPdfStampInput() {
        var array = []
        for(var ii = 0; ii < this.imagePdfItems.length; ii++) {
          var item = Object.assign([], this.imagePdfItems[ii])
          item.koordinat.base64Src = this.imagePdfItems[ii].path
          array.push(item.koordinat)
        }
        this.pdfSubmit = await this.convertPdfToBase64()
        this.imgParameter =  JSON.stringify(array)
      }
    
  },
  
  
}
</script>